import axios from 'axios';


export const ACCESS_TOKEN = 'Access-Token';
export const USER_NAME = 'Login_Username';
export const USER_INFO = 'Login_Userinfo';
export const UI_CACHE_DB_DICT_DATA = 'UI_CACHE_DB_DICT_DATA'
export const getAction = (url,parameter)=>{
    return axios({
        url: url,
        method: 'get',
        params: parameter
    })
}

export function logout(url,logoutToken,refreshToken) {
    // refresh_token作为query参数传给后端一并吊销（登出后旧refresh_token立即失效）
    let requestUrl = url
    if (refreshToken) {
        requestUrl = url + (url.indexOf('?') !== -1 ? '&' : '?') + 'refreshToken=' + encodeURIComponent(refreshToken)
    }
    return axios({
        // url: '/sys/logout',
        url: requestUrl,
        method: 'get',
        // 显式带上token，退出时本地sessionStorage已清空，
        // 不依赖请求拦截器从sessionStorage取token，确保后端能据此注销登录态
        headers: {
            'ACCESS_TOKEN':  logoutToken
        }
    })
}




